import * as Yup from 'yup';

const city = Yup.string().when('isRm', {
  is: true,
  then: Yup.string().required('City is required'),
});

export default city;
